import React from 'react';
import Blogs from '../../components/blogs';

const BlogsPage = () => {
  return (
    <>
      <Blogs />
    </>
  );
};

export default BlogsPage;
